import React from "react";

/*
 * started creating a small code display for listing
 * issue with passing in course_code_a and subject
 */
const CourseCodeSmall = (props) => {
  const course_code = props.course_code_a.split(",").map((v, i) => {
    let key = "ccode-" + i;
    return (
      <div
        id={key}
        key={key}
        className="bg-light card d-flex flex-row justify-content-center sm-buffer-right course-code-test"
        style={{ width: "1.4rem", height: "1.4rem", fontSize: ".9rem" }}
      >
        {v}
      </div>
    );
  });

  return (
    <div className="d-flex" style={{ maxWidth: "12rem" }}>
      <div
        className="bg-light card d-flex flex-row justify-content-center sm-buffer-right sm-inner-buffer-horizontal"
        style={{ maxWidth: "6rem", height: "1.4rem", fontSize: ".9rem" }}
      >
        {props.subject ? props.subject.name : ""}
      </div>
      {course_code}
    </div>
  );
};

export default CourseCodeSmall;
